import { render, staticRenderFns } from "./ReceivedRecordings.vue?vue&type=template&id=49d70fc2&scoped=true"
import script from "./ReceivedRecordings.vue?vue&type=script&lang=js"
export * from "./ReceivedRecordings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d70fc2",
  null
  
)

export default component.exports